import { AgentPortalFeatureCode } from '@wallet-manager/pfh-pmp-node-def-types';
import { Dispatch, SetStateAction } from 'react';
import { usePageConfigProviderContext } from 'src/common/page/PageConfigProvider';
import { Button } from 'src/components/MuiGenerals';
import { usePermission, useTranslation } from 'src/hooks';
import { COLOR_THEME } from 'src/style/colorTheme';

type Props = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const BatchAllocateCreditDialogToggle = (props: Props) => {
  const { setIsOpen } = props;
  const { translatePrefix } = usePageConfigProviderContext();

  const { t } = useTranslation(translatePrefix);
  const { hasPermission } = usePermission();

  const batchAllocateCreditPermission =
    AgentPortalFeatureCode.ClientManagement.CreditAllocation.CreateBatchAllocate;

  const onClick = () => {
    setIsOpen(true);
  };

  return (
    <>
      {hasPermission(batchAllocateCreditPermission) && (
        <Button
          variant="outlined"
          style={{
            color: COLOR_THEME.CustomSx.DatagridContainer.ButtonText,
            borderColor: COLOR_THEME.CustomSx.DatagridContainer.ButtonBorder,
          }}
          onClick={onClick}
          children={t('batchAllocateCredit')}
        />
      )}
    </>
  );
};
export default BatchAllocateCreditDialogToggle;
